import React, { useState } from 'react';
import {
    FormControl,
    Select,
    MenuItem,
    InputBase,
    IconButton,
    SelectChangeEvent,
    Grid,
    Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface CustomSelectOptionProps {
    value: string;
    onChange: (event: SelectChangeEvent<any>) => void;
    options: { value: string; label: string }[];
    icon?: JSX.Element;
}

const CustomSelectOption: React.FC<CustomSelectOptionProps> = ({
    value,
    onChange,
    options,
    icon,
}) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleValueChange = (event: SelectChangeEvent<any>) => {
        onChange(event);
        handleClose();
    };

    return (
        <FormControl>
            <Grid container alignItems="center">
                <Grid item xs={10}>
                    <Select
                        value={value}
                        onChange={handleValueChange}
                        open={open}
                        onClose={handleClose}
                        onOpen={handleOpen}
                        input={<InputBase />}
                        IconComponent={() => null}
                        renderValue={(selected) => (
                            <Box sx={{
                                display: 'flex', alignItems: 'center', gap: 1,
                                px: 2
                            }}>

                                <span>{selected}</span>
                                {icon}
                            </Box>
                        )}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                            },
                            transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left',
                            },
                        }}
                    >
                        {options.map((option, index) => (
                            <MenuItem key={index} value={option.value}
                                sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                {icon}
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
                <Grid item xs={2}>
                    <IconButton
                        disableRipple
                        sx={{
                            padding: 0,

                            '&:hover': {
                                backgroundColor: 'transparent',
                            },
                        }}
                        onClick={handleOpen}
                    >
                        <ExpandMoreIcon />
                    </IconButton>
                </Grid>
            </Grid>
        </FormControl>
    );
};

export default CustomSelectOption;
